import { ReactNode } from 'react';
import { useSingleton } from 'src/hooks';
import { QueryClient, QueryClientProvider } from 'react-query';


const defaultClient = () => new QueryClient({
  defaultOptions: {
    queries: {
      retry: false,
      refetchOnWindowFocus: false,
      refetchInterval: false,
      refetchIntervalInBackground: false,
      staleTime: 5 * 60 * 1000 // 5 minutes
    }
  }
});

// Module singleton shared by the main app root (entry.jsx) and the imperative rich-text bridge
// (mountRichText), so injected editors reuse the app's cache (e.g. usePreferences) rather than
// creating their own client and refetching on every mount/focus.
export const queryClient = defaultClient();

const DefaultQueryClientProvider = ({ children }: { children?: ReactNode | undefined }) => {

  const client = useSingleton(defaultClient);

  return (
    <QueryClientProvider client={client}>{children}</QueryClientProvider>
  );
};


export default DefaultQueryClientProvider;
